export default "__VITE_ASSET__e6a5c33f__"